module.exports = __webpack_public_path__ + "img/vue-logo-old.02c850cc.png";